export function getCountryNameFromCode(countryCode, locale) {
  let regionNames = new Intl.DisplayNames([locale], { type: "region" });
  return regionNames.of(countryCode);
}
